import { render, staticRenderFns } from "./worker-management.vue?vue&type=template&id=64a6d876&scoped=true&"
import script from "./worker-management.vue?vue&type=script&lang=js&"
export * from "./worker-management.vue?vue&type=script&lang=js&"
import style0 from "./worker-management.vue?vue&type=style&index=0&id=64a6d876&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a6d876",
  null
  
)

export default component.exports